/** account-created-*.html next steps by role */

export const ACCOUNT_CREATED = {
  GP: {
    title: 'Account Created!',
    subtitle: 'Your RotationStreet account is ready.\nYour work email has been verified.',
    steps: [
      { title: 'Complete your profile', text: 'Add your investment preferences to get personalized deal matches.' },
      { title: 'Start exploring', text: 'Browse deals, post opportunities, or connect with investors.' },
    ],
    cta: 'Start Exploring →',
  },
  LP: {
    title: 'Account Created!',
    subtitle: 'Your RotationStreet account is ready.\nYour work email has been verified.',
    steps: [
      { title: 'Set investment preferences', text: 'Tell us your sectors and regions to receive matched deals.' },
      { title: 'Discover opportunities', text: 'Browse GP funds and connect with verified managers.' },
    ],
    cta: 'Start Exploring →',
  },
  Startup: {
    title: 'Account Created!',
    subtitle: 'Welcome to RotationStreet Startup Portal.',
    steps: [
      { title: 'Complete company profile', text: 'Add funding stage, sector, and pitch materials.' },
      { title: 'Start fundraising', text: 'Publish your raise and reach global investors.' },
    ],
    cta: 'Go to Dashboard →',
  },
  ServiceProvider: {
    title: 'Account Created!',
    subtitle: 'Your service provider account is ready.',
    steps: [
      { title: 'Complete firm profile', text: 'Add your service areas and credentials.' },
      { title: 'Join active deals', text: 'Collaborate with GPs, LPs, and startups on live transactions.' },
    ],
    cta: 'Go to Dashboard →',
  },
  Admin: {
    title: 'Admin Access Granted',
    subtitle: 'Your administrator account has been created.',
    steps: [
      { title: 'Review registrations', text: 'Approve new users and verify email domains.' },
      { title: 'Monitor platform', text: 'Access analytics, compliance, and user management.' },
    ],
    cta: 'Open Admin Panel →',
  },
}

export function resolveAccountCreatedRole(role) {
  return ACCOUNT_CREATED[role] || ACCOUNT_CREATED.GP
}
